import React from "react";
import { Typography } from "@mui/material";

export interface BoldTextProps {
  text: string;
}

const BoldText: React.FC<BoldTextProps> = ({ text }) => {
  if (!text?.trim()) return null;

  const boldRegex = /\*\*(.*?)\*\*/g;
  const parts = text?.split(boldRegex);

  return (
    <Typography>
      {parts?.map((part, index) =>
        index % 2 === 1 ? (
          <Typography key={index} sx={{ fontWeight: 600, display: "inline" }}>
            {part}
          </Typography>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      )}
    </Typography>
  );
};

export default BoldText;
